import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../../../core/constants/api-endpoints';
import { HttpService } from '../../../core/services/http/http.service';
import type {
  BillingAddOnsCatalogApiResponse,
  BillingPlansCatalogApiResponse,
} from '../billing-catalog.models';

@Injectable({ providedIn: 'root' })
export class BillingCatalogApiService {
  private readonly http = inject(HttpService);

  getPlans(): Observable<BillingPlansCatalogApiResponse> {
    return this.http.get<BillingPlansCatalogApiResponse>(API_ENDPOINTS.BILLING.PLANS, {
      withCredentials: true,
    });
  }

  getAddOns(): Observable<BillingAddOnsCatalogApiResponse> {
    return this.http.get<BillingAddOnsCatalogApiResponse>(API_ENDPOINTS.BILLING.ADDONS, {
      withCredentials: true,
    });
  }
}
